import React from "react";
import "./styles.css";

export default function ItemSituacaoEmpty({ children }: React.PropsWithChildren<{}>) {
  return <p className="item-situacao-empty">{children}</p>;
}
